export enum GeocodingPrecision {
  House = 'HOUSE',
  Street = 'STREET',
  City = 'CITY',
  Country = 'COUNTRY',
  None = 'NONE'
}
